var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8_trash_can",
    d: "M15,4a3.011,3.011,0,0,0-3,3H8.873A.686.686,0,0,0,8.63,7H6.75a.75.75,0,1,0,0,1.5H8V21.25A2.761,2.761,0,0,0,10.75,24h8.5A2.761,2.761,0,0,0,22,21.25V8.5h1.25a.75.75,0,1,0,0-1.5H21.373a.75.75,0,0,0-.243,0H18A3.011,3.011,0,0,0,15,4Zm0,1.5A1.489,1.489,0,0,1,16.5,7h-3A1.489,1.489,0,0,1,15,5.5Zm-5.5,3h11V21.25a1.239,1.239,0,0,1-1.25,1.25h-8.5A1.239,1.239,0,0,1,9.5,21.25Zm3.738,2.489a.75.75,0,0,0-.738.761v7.5a.75.75,0,1,0,1.5,0v-7.5a.75.75,0,0,0-.762-.761Zm3.5,0A.75.75,0,0,0,16,11.75v7.5a.75.75,0,1,0,1.5,0v-7.5a.75.75,0,0,0-.762-.761Z",
    transform: "translate(-6 -4)",
    fill: "#5b5b5b"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/iconTrash.62480fbbf3afa77540253dc9f865af1a.svg";
export { ForwardRef as ReactComponent };